import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getDashboardPathForRole } from "../utils/tokenUtils";

/**
 * Route guard that enforces authentication and role-based authorization.
 *
 * - No token → redirect to login
 * - Role not in allowedRoles → redirect to role's dashboard (not login)
 */
const PrivateRoute = ({ allowedRoles, element }) => {
  const { accessToken, role } = useSelector((state) => state.auth);

  if (!accessToken) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles || !allowedRoles.includes(role)) {
    const dashboardPath = getDashboardPathForRole(role);
    return <Navigate to={dashboardPath} replace />;
  }

  return element;
};

export default PrivateRoute;
